import React, { useState } from 'react';
import BackgroundJobErrorsModal from './BackgroundJobErrorsModal';
import { Button } from '../util/buttons';
import { useTranslation } from 'react-i18next';
export default function BackgroundJobStatusDisplay(_ref) {
  let {
    jobStatusObject,
    errorsArrayPropertyName = 'import_errors',
    errorTableHeaders,
    buildErrorTableRowFn,
    onSuccessMessage = 'The data was imported successfully!',
    onErrorMessage = 'There were errors importing the data.',
    onNeverMessage = 'The data was never imported.',
    onPendingMessage = 'Pending',
    modalTitle = 'Import Errors',
    errorButtonText = 'You can check them here',
    className = ''
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  // default error table headers
  if (!errorTableHeaders) {
    errorTableHeaders = [{
      text: t('error')
    }];
  }

  // default build error table row function
  if (!buildErrorTableRowFn) {
    buildErrorTableRowFn = (importError, index) => {
      return {
        key: index,
        columns: [importError]
      };
    };
  }
  const renderStatus = () => {
    if (jobStatusObject) {
      switch (jobStatusObject.import_status) {
        case 'imported_successfully':
          return onSuccessMessage;
        case 'imported_unsuccessfully':
          return /*#__PURE__*/React.createElement("span", {
            className: "BackgroundJobStatusDisplay-errorStatus"
          }, onErrorMessage, /*#__PURE__*/React.createElement(Button, {
            className: "BackgroundJobStatusDisplay-errorStatus-button--default BackgroundJobStatusDisplay-errorStatus-button",
            variant: "link",
            onClick: () => setShowModal(true)
          }, errorButtonText));
        case 'pending':
          return onPendingMessage;
        default:
          return t('background_job_was_never_performed');
      }
    } else {
      return onNeverMessage;
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, "\n        .BackgroundJobStatusDisplay-errorStatus-button--default {\n          margin: 0;\n          padding: 0;\n        }\n      "), showModal && /*#__PURE__*/React.createElement(BackgroundJobErrorsModal, {
    errorTableHeaders: errorTableHeaders,
    buildErrorTableRowFn: buildErrorTableRowFn,
    jobStatusObject: jobStatusObject,
    errorsArrayPropertyName: errorsArrayPropertyName,
    title: modalTitle,
    show: showModal,
    onHide: () => {
      setShowModal(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "BackgroundJobStatusDisplay ".concat(className)
  }, renderStatus()));
}